import 'es6-promise/auto';
import 'core-js/stable';
import 'regenerator-runtime/runtime';

import Vue from 'vue';
import Vuex from 'vuex';
import VueI18n from 'vue-i18n';

import BootstrapVue from 'bootstrap-vue';

import App from '../term_filter/App.vue';
import AppOnline from '../term_filter/AppOnline.vue';
import AppVirtual from '../term_filter/AppVirtual.vue';

import store from '../term_filter/store';

import { currency } from '../term_filter/filters/currency';
import { date, dayName } from '../term_filter/filters/dates';

import i18n from '../lib/i18n';

Vue.use(BootstrapVue);

Vue.filter('currency', currency);
Vue.filter('date', date);
Vue.filter('dayName', dayName);

Vue.use(VueI18n);
Vue.use(Vuex);

document.addEventListener('DOMContentLoaded', () => {
  const element = document.getElementById('term-filter');
  const onlineElement = document.getElementById('term-filter-online');
  const virtualElement = document.getElementById('term-filter-virtual');

  /* eslint no-new: 0 */

  if (element != null) {
    new Vue({
      el: '#term-filter',
      i18n,
      store,
      components: { App },
      render: h => h(App),
    });
  }


  /* eslint no-new: 0 */

  if (onlineElement != null) {
    new Vue({
      el: '#term-filter-online',
      i18n,
      store,
      components: { AppOnline },
      render: h => h(AppOnline),
    });
  }

  if (virtualElement != null) {
    new Vue({
      el: '#term-filter-virtual',
      i18n,
      store,
      components: { AppVirtual },
      render: h => h(AppVirtual),
    });
  }
});
